import Types from './Types'
import Api from '../services/Api'

export const userLogin = (email, password) => async dispatch => {
  const {uid, role, token} = await Api.login(email, password);
  dispatch(setUser({uid, role, token}));
};

export const userLogout = () => async dispatch => {
  Api.logout();
  dispatch({type: Types.LOGOUT});
};

const setUser = payload => ({
  type: Types.SET_USER,
  payload,
});



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js